type MatomoMessageKeys = string | number | EventTarget | boolean;

export default class MatomoMessage {
  private messageKeys: MatomoMessageKeys[];

  public constructor(keys: MatomoMessageKeys[]) {
    this.messageKeys = keys;
  }

  public with(key: MatomoMessageKeys): MatomoMessage {
    return new MatomoMessage(this.messageKeys.concat([key]));
  }

  public publish() {
    const paq = MatomoMessage.getMatomoQueue();
    if (paq) {
      try {
        paq.push(Array.from(this.messageKeys));
      } catch (e) {
        /* tslint:disable */
        console.debug(e);
        /* tslint:enable */
        // fail-silent we do not want that tracking-code blocks business-logic
      }
    }
  }

  private static getMatomoQueue(): any {
    return (window as any)._paq ? (window as any)._paq : null;
  }

}
